import styled from "@emotion/native";
import { ViewStyle } from "react-native";
import * as drawer from "../../utils/drawer";

export const CONTAINER_WIDTH = 50;

export const OuterContainer = styled.View(
	{
		position: "absolute",
		width: drawer.BUTTON_WIDTH,
		height: drawer.BUTTON_HEIGHT,
		left: drawer.BUTTON_LEFT,
		top: drawer.BUTTON_TOP,
		zIndex: 100,
		alignItems: "center",
		justifyContent: "center",
	},
	({ theme }: any) => {
		let style: ViewStyle = {};

		if (theme.verticalScale < 1) {
			const width = drawer.BUTTON_WIDTH * theme.verticalScale;
			const height = drawer.BUTTON_HEIGHT * theme.verticalScale;
			const left = drawer.BUTTON_LEFT * theme.verticalScale;
			const top = drawer.BUTTON_TOP * theme.verticalScale;

			style = {
				width,
				height,
				left,
				top,
			};
		}

		return style;
	}
);

export const Container = styled.View(
	{
		width: CONTAINER_WIDTH,
		height: CONTAINER_WIDTH,
		borderRadius: CONTAINER_WIDTH / 2,
		alignItems: "center",
		justifyContent: "center",
	},
	({ theme }: any) => {
		let style: ViewStyle = {
			backgroundColor: theme.color.accent,
		};

		if (theme.verticalScale < 1) {
			const delta = (1 - theme.verticalScale) / 2;
			const verticalScale = 1 - delta;
			const width = CONTAINER_WIDTH * verticalScale;
			const height = width;

			style = {
				...style,
				width,
				height,
			};
		}

		return style;
	}
);

export const Icon = styled.Image({
	flex: 1,
	resizeMode: "contain",
});
